/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_DeliveryInputs */

const en_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery Channel`)
};

const es_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal de entrega`)
};

const fr_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal de livraison`)
};

const de_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferkanal`)
};

const ja_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`納品方法/チャネル`)
};

const zh_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交付渠道`)
};

const ar_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قناة التسليم`)
};

const id_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saluran Pengiriman`)
};

const it_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metodo di Consegna`)
};

const ru_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Способ доставки/передачи`)
};

const pt_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal de Entrega`)
};

const ko_field_delivery = /** @type {(inputs: Field_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전달 방식`)
};

/**
* | output |
* | --- |
* | "Delivery Channel" |
*
* @param {Field_DeliveryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_delivery = /** @type {((inputs?: Field_DeliveryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_DeliveryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_delivery(inputs)
	if (locale === "es") return es_field_delivery(inputs)
	if (locale === "fr") return fr_field_delivery(inputs)
	if (locale === "de") return de_field_delivery(inputs)
	if (locale === "ja") return ja_field_delivery(inputs)
	if (locale === "zh") return zh_field_delivery(inputs)
	if (locale === "ar") return ar_field_delivery(inputs)
	if (locale === "id") return id_field_delivery(inputs)
	if (locale === "it") return it_field_delivery(inputs)
	if (locale === "ru") return ru_field_delivery(inputs)
	if (locale === "pt") return pt_field_delivery(inputs)
	return ko_field_delivery(inputs)
});